///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.events = abcsetup.events || {};
abcsetup.events.common = abcsetup.events.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.events.common = {
    init: function () {
        // Approval all button clicked
        $(document).on('click', '#btn-approve-all', function (e) {
            $('input:radio[value="cm_approved"], input:radio[value="event_admin_approved"]').trigger('click').closest('tr').removeClass().addClass('approved');
            $('#global_reject_reason').addClass('d-none');
        });

        $(document).on('click', 'input:radio[value="cm_approved"]', function (e) {
            $(this).closest('tr').removeClass().addClass('approved');
            $(this).closest('tr').next('tr.reject_reason').remove();
        });

        $(document).on('click', 'input:radio[value="event_admin_approved"]', function (e) {
            $(this).closest('tr').removeClass().addClass('approved');
            $(this).closest('tr').next('tr.reject_reason').remove();
        });

        $(document).on('click', 'input:radio[value="cm_rejected"]', function (e) {
            const event_item_id = $(this).data('id');
            const reject_reason = $(this).data('rejection_reason');
            $(this).closest('tr').removeClass().addClass('rejected');
            $(this).closest('tr').next('tr.reject_reason').remove();
            $(this).closest('tr').after(abcsetup.events.common.getRejectTextarea(event_item_id, reject_reason));
        });

        $(document).on('click', 'input:radio[value="cm_reject_disable"]', function (e) {
            const event_item_id = $(this).data('id');
            const reject_reason = $(this).data('rejection_reason');
            $(this).closest('tr').removeClass().addClass('rejected');
            $(this).closest('tr').next('tr.reject_reason').remove();
            $(this).closest('tr').after(abcsetup.events.common.getRejectTextarea(event_item_id, reject_reason));
        });

        $(document).on('click', 'input:radio[value="event_admin_rejected"]', function (e) {
            const event_item_id = $(this).data('id');
            const reject_reason = $(this).data('rejection_reason');
            $(this).closest('tr').removeClass().addClass('rejected');
            $(this).closest('tr').next('tr.reject_reason').remove();
            $(this).closest('tr').after(abcsetup.events.common.getRejectTextarea(event_item_id, reject_reason));
        });

        $(document).on('click', 'input:radio[value="event_admin_reject_disable"]', function (e) {
            const event_item_id = $(this).data('id');
            const reject_reason = $(this).data('rejection_reason');
            $(this).closest('tr').removeClass().addClass('rejected');
            $(this).closest('tr').next('tr.reject_reason').remove();
            $(this).closest('tr').after(abcsetup.events.common.getRejectTextarea(event_item_id, reject_reason));
        });

        // Reset all button clicked
        $(document).on('click', '#btn-reset-all', function (e) {
            $('.reject_reason').remove();
            $('input:radio[value="cm_approved"]').prop('checked', false);
            $('input:radio[value="cm_rejected"]').prop('checked', false);
            $('input:radio[value="cm_reject_disable"]').prop('checked', false);
            $('input:radio[value="event_admin_approved"]').prop('checked', false);
            $('input:radio[value="event_admin_rejected"]').prop('checked', false);
            $('input:radio[value="event_admin_reject_disable"]').prop('checked', false);
            $('tr.rejected').removeClass('rejected');
            $('tr.approved').removeClass('approved');
            $('#global_reject_reason').addClass('d-none');
        });

        $(document).on('click', '#btn-reject-all', function(e) {
            $('input:radio[value="cm_rejected"]').trigger('click').closest('tr').removeClass().addClass('rejected');
            $('input:radio[value="event_admin_rejected"]').trigger('click').closest('tr').removeClass().addClass('rejected');
            $('.reject_reason').remove(); //remove the individual reject reason boxes
            $('#global_reject_reason').removeClass('d-none');
        });
    },

    getRejectTextarea: function (id, reason) {
        return `
            <tr class="reject_reason" style="border: none">
                <td colspan="3">You must supply a rejection reason <i style="color: red;">*</i><br/>
                    <textarea name="reject_reason[${id}]" class="form-control" placeholder="Rejection reason" required>${reason}</textarea>
                </td>
            </tr>
        `
    }
}
